import React, { ReactElement } from 'react';
import MainLayout from 'layouts/main-layout/main-layout';
import './error-page.scss';
import { useTranslate } from 'hooks/translate';

export default function ErrorPage(): ReactElement {
  const { t } = useTranslate();
  return (
    <MainLayout>
      <h1 className='page-not-found'>{t('errors.pageNotFound')}</h1>
    </MainLayout>
  );
}
